import { enableProdMode, StaticProvider } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { API_URL, IS_SERVER_SIDE, SSR_PAGE_DATA } from './app/tokens';
import { environment } from './environments';

if (environment.production) {
    enableProdMode();
}

const extraProviders: StaticProvider[] = [
    { provide: API_URL, useValue: environment.apiUrl },
    { provide: IS_SERVER_SIDE, useValue: false },
    { provide: SSR_PAGE_DATA, useValue: null },
];

bootstrapApplication(AppComponent, {
    ...appConfig,
    providers: [...(appConfig.providers ?? []), ...extraProviders],
}).catch((err: unknown) => console.error('Angular bootstrap failed', err));
